import {
  AuthContext,
  authContextSchema,
} from "@boark/shared/types/auth-context";

import { request } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getUserContext(language: string): Promise<AuthContext> {
  return await request(`${API_BASE_URL}/user-context`, {
    schema: authContextSchema,
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": language,
    },
  });
}
